import Api from '../../Api';
import Constants from '../../Constants';
import { BANNER_DATA, BANNER_RESET } from '../../actionTypes/Notifications/Notifications';
import { onErrorMsg } from '../FlashMessage/FlashMessages';

export const loadAdminBanners = () => {
  return async (dispatch) => {
    try {
      const api = new Api();
      const banners = await api.getData(Constants.apiUrls.adminBanners);
      dispatch({ type: BANNER_DATA, payload: banners });
    } catch (err) {
      dispatch({ type: BANNER_RESET });
    }
  };
};

export const loadAdminBanner = (id) => {
  const api = new Api();
  const { adminBanners } = Constants.apiUrls;
  return api.getData(`${adminBanners}/${id}`);
};

export const deleteAdminBanner = (bannerId) => {
  return async (dispatch) => {
    try {
      const api = new Api();
      const { adminBanners } = Constants.apiUrls;
      await api.delData(`${adminBanners}/${bannerId}`);
    } catch (err) {
      dispatch({ type: BANNER_RESET });
      dispatch(onErrorMsg());
    }
  };
};
